module.exports = __webpack_public_path__ + "img/ubank-large.c68b0818.png";